/*
 * Colour swatches on a product card.
 *
 * Clicking a swatch replaces the card's photograph with the image of the
 * variant that colour belongs to. The URLs are already on each button as data
 * attributes, so no request is made and the swap is immediate.
 *
 * Delegated from the document rather than bound per card: the collection grid
 * paginates, the carousel clones slides, and the theme editor re-renders
 * sections — all of which produce cards after this file has run. One listener
 * covers every card that will ever exist.
 */
(function () {
  'use strict';

  var SWATCH = '[data-mk-swatch]';
  var GROUP = '[data-mk-swatches]';

  /* The card's main image. Dawn nests it differently per surface, so the
     closest card wrapper is found first and the image taken from within it. */
  function findCardImage(swatch) {
    var card =
      swatch.closest('.card-wrapper') ||
      swatch.closest('.mk-pcar__card') ||
      swatch.closest('.card') ||
      swatch.closest('li');
    if (!card) return null;
    return card.querySelector('.card__media img, .mk-pcar__image img, .media img, img');
  }

  function select(swatch) {
    var group = swatch.closest(GROUP);
    if (!group) return;

    var image = findCardImage(swatch);
    var src = swatch.getAttribute('data-mk-swatch-image');
    var srcset = swatch.getAttribute('data-mk-swatch-srcset');

    // A swatch with no image still takes the selected state: the colour is
    // real even when it has no photograph of its own, so the control should
    // not look inert.
    if (image && src) {
      // sizes is left as the theme set it — the card's slot has not changed,
      // only which photograph fills it.
      if (srcset) {
        image.srcset = srcset;
      } else {
        image.removeAttribute('srcset');
      }
      image.src = src;
    }

    group.querySelectorAll(SWATCH).forEach(function (other) {
      other.removeAttribute('aria-current');
    });
    swatch.setAttribute('aria-current', 'true');
  }

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest(SWATCH);
    if (!swatch) return;

    // The swatches sit inside the card's link, so a click would otherwise
    // navigate to the product instead of swapping the image.
    event.preventDefault();
    event.stopPropagation();

    select(swatch);
  });

  /* Enter and Space already activate a <button>, so keyboard support needs no
     code of its own. Arrow-key movement within the group is added so a long
     colour row behaves like the single control it reads as. */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;

    var swatch = event.target.closest(SWATCH);
    if (!swatch) return;

    var group = swatch.closest(GROUP);
    if (!group) return;

    var all = Array.prototype.slice.call(group.querySelectorAll(SWATCH));
    var index = all.indexOf(swatch);
    if (index === -1) return;

    var next = event.key === 'ArrowRight' ? index + 1 : index - 1;
    if (next < 0 || next >= all.length) return;

    event.preventDefault();
    all[next].focus();
    select(all[next]);
  });
})();
